import BaseModel from '../model/BaseModel';

export default class ConcessionItem extends BaseModel {

    constructor(data) {
        super();
        this.Id =  data.ItemId || data.Id;
        this.ItemId = data.ItemId || data.Id;
        this.Description = data.Description;
        this.Quantity = data.Quantity;
        this.PriceInCents = data.PriceInCents;
        this.RecognitionId = data.RecognitionId;
        this.RecognitionSequenceNumber = data.RecognitionSequenceNumber;

    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/ConcessionItem.js